import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import styles from "./LazyImage.module.scss";

interface LazyImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  className?: string;
}

export const LazyImage: React.FC<LazyImageProps> = ({
  src,
  alt,
  className,
  ...props
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const imgRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry && entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      { rootMargin: "50px" },
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const loadedClass = styles["is-loaded"] || "is-loaded";

  return (
    <div
      ref={imgRef}
      className={classNames(styles["image-wrapper"], className)}>
      {isInView && (
        <img
          src={src}
          alt={alt}
          className={classNames(styles["image"], {
            [loadedClass]: isLoaded,
          })}
          onLoad={() => setIsLoaded(true)}
          {...props}
        />
      )}
      {!isLoaded && <div className={styles["placeholder"]} />}
    </div>
  );
};
